/* RESPONSIBLE TEAM: team-inbox */
import { inject as service } from '@ember/service';
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';

export default SettingsRoute.extend({
  intercomEventService: service(),
  permissionsService: service(),

  beforeModel(transition) {
    this._super(...arguments);
    return this.permissionsService.ensurePermissionWhenTransitioning(
      'can_access_workspace_settings',
      transition,
    );
  },
});
